import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProgressMeetingActions from './progress-meeting.actions';
import { ProgressMeetingService } from '../../services/progress-meeting.service';
import { Router } from '@angular/router';

@Injectable()
export class ProgressMeetingEffects {
  loadProgressMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMeetingActions.loadProgressMeeting),
      exhaustMap((_) =>
        this.progressMeetingService.getProgressMeeting().pipe(
          map((data) =>
            ProgressMeetingActions.loadProgressMeetingSuccess({
              progressMeeting: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProgressMeetingActions.loadProgressMeetingFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProgressMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMeetingActions.addProgressMeeting),
      concatMap(({ newProgressMeeting }) =>
        this.progressMeetingService
          .createProgressMeeting(newProgressMeeting)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProgressMeetingActions.addProgressMeetingSuccess({
                newProgressMeeting: data,
              });
            }),
            catchError((error) => {
              console.log('error ', error);

              return of(
                ProgressMeetingActions.addProgressMeetingFailure({
                  error: error.error.message,
                })
              );
            })
          )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProgressMeetingActions.addProgressMeetingSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProgressMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMeetingActions.updateProgressMeeting),
      concatMap(({ updateProgressMeeting }) =>
        this.progressMeetingService
          .updateProgressMeeting(updateProgressMeeting)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProgressMeetingActions.updateProgressMeetingSuccess({
                updateProgressMeeting: data,
              });
            }),
            catchError((error) => {
              return of(
                ProgressMeetingActions.updateProgressMeetingFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProgressMeetingActions.updateProgressMeetingSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProgressMeeting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressMeetingActions.removeProgressMeeting),
      map((action) => action.ids),
      concatMap((ids) =>
        this.progressMeetingService.deleteProgressMeeting(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProgressMeetingActions.removeProgressMeetingSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProgressMeetingActions.updateProgressMeetingFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private progressMeetingService: ProgressMeetingService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
